module.exports = __webpack_public_path__ + "img/index9.477580a1.png";